import React, { useState } from "react";
import { Card, Row, Col } from "react-bootstrap";
import { FaStar, FaEdit, FaTrash, FaCheck, FaTimes } from "react-icons/fa";
import { useClientAuth } from "../../../context/ClientAuthContext";
import CommentService from "../../../services/comment";
import { showErrorToaster } from "../../../adminCompenents/listComponents/UI/toaster/error";
import { showSuccessToaster } from "../../../adminCompenents/listComponents/UI/toaster/success";
import "./index.scss";

const commentService = new CommentService();

const CommentItem = ({ comment, onUpdate, onDelete }) => {
  const { currentClient } = useClientAuth();
  const [isEditing, setIsEditing] = useState(false);
  const [editText, setEditText] = useState(comment.comment);
  const [isLoading, setIsLoading] = useState(false);

  const isOwner = currentClient && currentClient.userId === comment.createdBy._id;

  const handleEdit = () => {
    setIsEditing(true);
    setEditText(comment.comment);
  };

  const handleCancel = () => {
    setIsEditing(false);
    setEditText(comment.comment);
  };

  const handleSave = async () => {
    if (!editText.trim()) {
      showErrorToaster("Le commentaire ne peut pas être vide");
      return;
    }

    setIsLoading(true);
    try {
      await commentService.updateComment(comment._id, { comment: editText.trim() });
      onUpdate(comment._id, editText.trim());
      setIsEditing(false);
      showSuccessToaster("Commentaire modifié avec succès");
    } catch (error) {
      showErrorToaster("Erreur lors de la modification du commentaire");
    } finally {
      setIsLoading(false);
    }
  };

  const handleDelete = async () => {
    if (window.confirm("Êtes-vous sûr de vouloir supprimer ce commentaire ?")) {
      setIsLoading(true);
      try {
        await commentService.deleteComment(comment._id);
        onDelete(comment._id);
        showSuccessToaster("Commentaire supprimé avec succès");
      } catch (error) {
        showErrorToaster("Erreur lors de la suppression du commentaire");
      } finally {
        setIsLoading(false);
      }
    }
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString("fr-FR", {
      day: "2-digit",
      month: "2-digit",
      year: "2-digit",
    });
  };

  const formatTime = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleTimeString("fr-FR", {
      hour: "2-digit",
      minute: "2-digit",
    });
  };

  // Generate a random rating between 3-5 for display (since we don't have rating in the schema)
  const rating = Math.floor(Math.random() * 3) + 3; // 3, 4, or 5

  return (
    <Card className="mb-3 comment-card">
      <Card.Body>
        <Row className="align-items-center">
          <Col md={12}>
            <div className="d-flex justify-content-between">
              <h6 className="comment-name">
                {comment.createdBy.name || comment.createdBy.email}
              </h6>
              <div className="d-flex align-items-center justify-content-end">
                <span className="me-1 icon-text">({rating})</span>
                <FaStar className="star-icon" />
                {isOwner && (
                  <div className="comment-actions ms-3">
                    {isEditing ? (
                      <>
                        <button
                          className="btn-save"
                          onClick={handleSave}
                          disabled={isLoading}
                          title="Sauvegarder"
                        >
                          <FaCheck />
                        </button>
                        <button
                          className="btn-cancel"
                          onClick={handleCancel}
                          disabled={isLoading}
                          title="Annuler"
                        >
                          <FaTimes />
                        </button>
                      </>
                    ) : (
                      <>
                        <button
                          className="btn-edit"
                          onClick={handleEdit}
                          disabled={isLoading}
                          title="Modifier"
                        >
                          <FaEdit />
                        </button>
                        <button
                          className="btn-delete"
                          onClick={handleDelete}
                          disabled={isLoading}
                          title="Supprimer"
                        >
                          <FaTrash />
                        </button>
                      </>
                    )}
                  </div>
                )}
              </div>
            </div>
            <div className="d-flex justify-content-between align-items-center">
              {isEditing ? (
                <textarea
                  value={editText}
                  onChange={(e) => setEditText(e.target.value)}
                  className="edit-textarea"
                  rows="3"
                  disabled={isLoading}
                />
              ) : (
                <p className="comment-text">{comment.comment}</p>
              )}
              <div className="comment-datetime">
                <small className="comment-date">{formatDate(comment.createdAt)}</small>
                <small className="comment-time">{formatTime(comment.createdAt)}</small>
              </div>
            </div>
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );
};

export default CommentItem;
